export { isFunction } from './code/isFunction';
export { maybeCall } from './code/maybeCall';
export { requiredParam } from './code/requiredParam';
export { verifyType } from './code/verifyType';

export { randomInt } from './math/randomInt';

export { repeater } from './jobs/repeater';

export * from './text';